/** Translated resolvesLabel ids ("Resolves", "Starts", ...) from describe(). */
import { t as tr, type PlainKey } from '../i18n/i18n';

const WHEN_KEY: Record<string, PlainKey> = {
  Resolves: 'describe.when.resolves',
  Starts: 'describe.when.starts',
  Decision: 'describe.when.decision',
  Deadline: 'describe.when.deadline',
};

/** The resolvesLabel id in the active language (unknown labels pass through). */
export function whenLabel(label: string | undefined): string {
  const k = WHEN_KEY[label ?? 'Resolves'];
  return k ? tr(k) : (label ?? '');
}
